import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.familyStatus;

const getFamilyStatus = createSelector(getData, familyStatus =>
  values(familyStatus)
);

export default getFamilyStatus;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getFamilyStatus.js